(function(){
  function num(t){t=(t||'').replace(/[^0-9,.]/g,'');if(t.indexOf(',')>-1){t=t.replace(/\./g,'').replace(',','.');}return parseFloat(t);}
  function pctFor(box){
    if(!box)return 0;
    var reg=box.querySelector('.price--on-sale .price__sale .price-item--regular, .price__sale s.price-item--regular');
    var sale=box.querySelector('.price--on-sale .price__sale .price-item--sale, .price__sale .price-item--sale');
    var r=num(reg&&reg.textContent),s=num(sale&&sale.textContent);
    return (r>s&&s>0)?Math.round((1-s/r)*100):0;
  }
  function mark(b,p){
    b.setAttribute('data-bf','1');
    b.classList.add('maxy-bf-badge');
    b.innerHTML='BLACK FRIDAY'+(p?'<span class="maxy-bf-pct">−'+p+'%</span>':'');
  }
  function run(){
    document.querySelectorAll('.card__badge .badge').forEach(function(b){
      if(b.getAttribute('data-bf'))return;
      var box=b.closest('.card-wrapper, .card, li');
      if(!box||!box.querySelector('.price--on-sale'))return;
      mark(b,pctFor(box));
    });
    document.querySelectorAll('.price__badge-sale').forEach(function(b){
      if(b.getAttribute('data-bf'))return;
      var box=b.closest('.price');
      mark(b,pctFor(box));
    });
  }
  function start(){run();try{new MutationObserver(run).observe(document.body,{childList:true,subtree:true});}catch(e){}}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start);}else{start();}
})();
